export default function isScreenSmall(){
    return window.innerWidth <= 800
}